import React from "react"
import * as styles from "./card.module.scss"

export const CardLoader = () => <div className={styles.container} />
